import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { InnerLocationService } from '../../../../global/services/innerLocation.service';
import { InnerLocation } from '../../../../global/types/InnerLocation';
import { Address } from '../../../../global/interfaces/address';
import { WorkingHours } from '../../../../global/types/WorkingHours';
import { ToastersService } from '../../../../global/services/toasters.service';

interface WorkingHoursChangeEvent {
  updatedWorkingHours: WorkingHours;
  dayIndex: number;
}
@Component({
  selector: 'app-add-inner-location',
  templateUrl: './add-inner-location.component.html',
  styleUrls: ['./add-inner-location.component.less'],
})
export class AddInnerLocationPopupComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  innerLocationData: InnerLocation;

  @Input() isEditingAvailable: boolean;

  constructor(
    private activeModal: NgbActiveModal,
    private innerLocationService: InnerLocationService,
    private toastersService: ToastersService,
  ) {}

  toggleIsEditingAvailable(event) {
    event.stopPropagation();
    this.isEditingAvailable = true;
  }

  ngOnInit(): void {
    this.subscription = this.innerLocationService.innerLocation$.subscribe((data) => (this.innerLocationData = data));
  }
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  updateName(newName: string): void {
    this.innerLocationData.name = newName;
  }

  updateAddress(newAddress: Address): void {
    this.innerLocationData.address = newAddress;
  }

  updateWorkingHours(event: WorkingHoursChangeEvent): void {
    const { updatedWorkingHours, dayIndex } = event;
    const propertyName = this.getDayPropertyName(dayIndex);
    this.innerLocationData[propertyName] = updatedWorkingHours;
  }

  getWorkingHoursArray(): WorkingHours[] {
    return [
      this.innerLocationData.workingHoursSunday,
      this.innerLocationData.workingHoursMonday,
      this.innerLocationData.workingHoursTuesday,
      this.innerLocationData.workingHoursWednesday,
      this.innerLocationData.workingHoursThursday,
      this.innerLocationData.workingHoursFriday,
      this.innerLocationData.workingHoursSaturday,
    ];
  }

  private getDayPropertyName(dayIndex: number): string | undefined {
    const daysOfWeek = [
      'workingHoursSunday',
      'workingHoursMonday',
      'workingHoursTuesday',
      'workingHoursWednesday',
      'workingHoursThursday',
      'workingHoursFriday',
      'workingHoursSaturday',
    ];

    return daysOfWeek[dayIndex];
  }

  private hasDuplicateGateNames(): boolean {
    const gateNames: string[] = [];
    const gates = this.innerLocationData.gates;

    for (const gate of gates) {
      const lowercaseName = gate.name.toLowerCase();
      if (gateNames.includes(lowercaseName)) {
        return true;
      }
      gateNames.push(lowercaseName);
    }

    return false;
  }

  async saveInnerLocation() {
    if (!this.innerLocationData.name || !this.innerLocationData.address.latitude) {
      this.toastersService.createErrorToast('Location Name and Address are required fields!');
      return;
    }
    if (this.hasDuplicateGateNames()) {
      this.toastersService.createErrorToast('Duplicate gate names are not allowed!');
      return;
    }
    this.activeModal.close(this.innerLocationData);
    this.innerLocationService.resetInnerLocationData();
  }

  closePopup() {
    this.innerLocationService.resetInnerLocationData();
    this.activeModal.close();
  }
}
